const doc = [({"da":({"js":({"admin":({"activities":({"politics":({"proposals":({"politics":"Politik"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;